export default {
  Gradebook: "Boletín de notas",
  Gradebooks: "Boletines de notas",
  edit_gradebook: "Introducción de boletines de notas",
  gradebook_finalization: "Finalización de los boletines de notas",
  empty_gradebook: "Por el momento no hay boletines de notas disponibles.",
  empty_gradebook_subject: "No hay información disponible para este periodo.",
  empty_gradebook_subject_exam: "No se ha registrado ningún examen para esta materia.",
  classroom: "Aula",
  gradebook: {
    absent: "Ausente",
    coefficient: {
      short: "Coef",
    },
    mark: "Nota",
    appreciation: "Valoración",
    appreciations: "Valoraciones",
    success: "¡Tu modificación se ha procesado correctamente!",
    min: "Min",
    max: "Max",
    average: {
      short: "Med",
      session: "Promedio del período",
    },
    export: {
      excel: {
        title: "Exportar el boletín de notas a Excel",
        confirmation: "¿Está seguro de que desea exportar el boletín de notas a Excel?",
      },
      pdf: {
        title: "Exportar el boletín de notas en PDF",
        confirmation: "¿Está seguro de que desea exportar el boletín de notas de este trinomio en PDF?",
        all: {
          title: "Exportar todos los boletines de notas en PDF",
          confirmation: "¿Está seguro de que desea exportar los boletines de notas de esta promoción en PDF?",
        },
      },
    },
    comment: {
      title: "Apreciación",
      general: "Valoración general",
      placeholder: "Agregar una apreciación (opcional)",
    },
    session: {
      is_valid: "Esta sesión está validada y es visible para los miembros de los tríos.",
      is_not_valid: "Esta sesión aún no ha sido validada, por lo que no es visible para los miembros de los tríos.",
      valid: "Publicar las notas de la sesión activa",
      unlock: "Desbloquear la sesión activa",
      valid_confirmation: "¿Está seguro de que desea validar la sesión activa?",
      unlock_confirmation: "¿Está seguro de que desea desbloquear el bloqueo de la sesión activa?",
      valid_success: "¡Sesión publicada con éxito!",
      unlock_success: "¡Sesión desbloqueada con éxito!",
      already_pulished: "Esta sesión ya está publicada; no puede modificarla.",
      ended: "Esta sesión ha finalizado, no es posible publicarla.",
    },
    triad: {
      unlock_entry: "Reabrir la entrada de esta nota",
      valid_entry: "Validar la introducción de esta nota",
      valid_confirmation: "¿Está seguro de que desea validar la introducción de esta nota?",
      unlock_confirmation: "¿Está seguro de que desea desbloquear la entrada de esta nota?",
      valid_success: "¡Nota validada con éxito!",
      unlock_success: "¡Nota desbloqueada con éxito!",
      save_note: "Guardar la entrada de la nota",
    },
    exam_type: "Tipo de examen",
    percent: {
      title: "Porcentaje del examen",
      help: "Ponderación de la nota del examen en el cálculo de la nota de la asignatura",
    },
    too_much_percent: "La suma de los porcentajes de los exámenes de esta asignatura debe ser igual a 100.",
    percentage: {
      edit: {
        valid: "Validar la introducción del porcentaje",
        success: "¡Porcentaje registrado con éxito!",
      },
    },
    ects: "Créditos ECTS",
    empty_subject: "No se ha registrado ninguna asignatura. Por favor, añada una primero haciendo clic aquí.",
    exempt: "Dispensado",
    reminder: {
      title: "Recordar al formador",
      confirmation: "¿Está seguro de que desea hacer un seguimiento con este formador?",
      success: "¡Seguimiento realizado con éxito!",
    },
    formers: {
      title: "Formadores",
    },
    write_by: ({ named }) => `Registrado por ${named("user")} el ${named("date")}`,
    write_on: ({ named }) => `, el ${named("date")}`,
    exemption: "Dispensa",
  },
};
